export abstract class SaveFiltersBase<T> {
  protected abstract localStorageKey: string;

  protected storeFilters(filters: T) {
    localStorage.setItem(this.localStorageKey, JSON.stringify(filters));
  }

  protected getStoredFilters(): T | null {
    const storedFilters = localStorage.getItem(this.localStorageKey);
    return storedFilters ? JSON.parse(storedFilters) : null;
  }
}
